angular.module('internalWebsiteApp').constant('ENV',{"beehive":"https://beehive.azurestandard.com","apiEndpoint":"https://api-internal.azurestandard.com"});